import { ValuableModel } from '../../models/ValuableModel'

export class SchemaBooleanModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Boolean': SchemaBooleanModel
  }
}
